import React from 'react';
import { Box, Grid, Card, CardContent, CardHeader } from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Loader } from '../Loader';

const CardSkeleton = () => (
  <Card variant="outlined">
    <CardHeader>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Skeleton />
        </Grid>
      </Grid>
    </CardHeader>
    <CardContent>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Skeleton />
        </Grid>
        <Grid item xs={6}>
          <Skeleton count={3} />
        </Grid>
        <Grid item xs={6}>
          <Skeleton count={3} />
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

const AspectSkeleton = () => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <Skeleton />
    </Grid>
    <Grid item xs={12}>
      <Skeleton />
    </Grid>
  </Grid>
);

const RequestSkeleton = () => (
  <Box sx={{ mt: 2 }}>
    <Loader />
    <Grid container spacing={2}>
      <Grid item xs={12} lg={3}>
        <AspectSkeleton />
      </Grid>
      <Grid item xs={12} lg={9}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6}>
            <CardSkeleton />
          </Grid>
          <Grid item xs={12} lg={6}>
            <CardSkeleton />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Box>
);

export { RequestSkeleton };
